import React, { useState, useEffect, useRef } from 'react';
import { FaHandshake, FaStore, FaRocket, FaMicrophone, FaChartPie, FaUsers } from 'react-icons/fa';
import './ServiciosSection.css';
import './EventosCarousel.css';

function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      { threshold: 0.3 }
    );
    const currentRef = ref.current;
    if (currentRef) observer.observe(currentRef);
    return () => { if (currentRef) observer.unobserve(currentRef); };
  }, [ref]);
  return isIntersecting;
}

function CounterServicios({ to }) {
  const [count, setCount] = useState(1);
  const ref = useRef();
  const visible = useOnScreen(ref);
  useEffect(() => {
    if (!visible) return;
    let start = 1;
    let end = to;
    let duration = 1200;
    let startTime = null;
    function animate(ts) {
      if (!startTime) startTime = ts;
      const progress = Math.min((ts - startTime) / duration, 1);
      setCount(Math.floor(progress * (end - start) + start));
      if (progress < 1) requestAnimationFrame(animate);
      else setCount(end);
    }
    requestAnimationFrame(animate);
  }, [visible, to]);
  return <span ref={ref} className="contador-eventos">+{count.toLocaleString()}</span>;
}

const frasesSlider = [
  'Conexiones Estratégicas',
  'Experiencias Únicas y Oportunas',
  'Crecimiento y Visibilidad'
];

const servicios = [
  {
    icon: <FaHandshake />, 
    titulo: 'Club Empresarial',
    descripcion: 'Comunidad exclusiva para generar alianzas estratégicas.'
  },
  {
    icon: <FaStore />, 
    titulo: 'Concept Store',
    descripcion: 'Exhibe y vende tus productos en un espacio exclusivo.'
  },
  {
    icon: <FaRocket />, 
    titulo: 'Lanzamiento de Marca',
    descripcion: 'Presenta tu negocio en eventos diseñados para el éxito.'
  },
  {
    icon: <FaMicrophone />, 
    titulo: 'Podcast',
    descripcion: 'Expón tu historia y marca en medios digitales.'
  },
  {
    icon: <FaChartPie />, 
    titulo: 'Marketing Digital',
    descripcion: 'Estrategias personalizadas para redes sociales y publicidad.'
  },
  {
    icon: <FaUsers />, 
    titulo: 'Emprelium',
    descripcion: 'Encuentra negocios recomendados y amplía tu red profesional con nuestra red social empresarial.'
  },
];

function ServicioCard({ serv, index }) {
  const iconRef = useRef();
  const isVisible = useOnScreen(iconRef);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (isVisible && !hasAnimated) {
      setHasAnimated(true);
    } else if (!isVisible && hasAnimated) {
      setHasAnimated(false);
    }
  }, [isVisible, hasAnimated]);

  return (
    <div className="servicio-card" style={{ animationDelay: `${index * 0.12}s` }}>
      <div 
        ref={iconRef}
        className={`servicio-icono ${hasAnimated ? 'icon-animated' : ''}`}
        style={{ '--card-index': index }}
      >
        {serv.icon}
      </div>
      <h3 className="servicio-nombre">{serv.titulo}</h3>
      <p className="servicio-desc">{serv.descripcion}</p>
    </div>
  );
}

export default function ServiciosSection() {
  const [fraseIndex, setFraseIndex] = useState(0);
  const [fraseAnim, setFraseAnim] = useState('slide-in');
  const fraseTimeout = useRef();

  useEffect(() => {
    setFraseAnim('slide-in');
    fraseTimeout.current = setTimeout(() => {
      setFraseAnim('slide-out');
      setTimeout(() => {
        setFraseIndex(i => (i + 1) % frasesSlider.length);
        setFraseAnim('slide-in');
      }, 500);
    }, 2000);
    return () => clearTimeout(fraseTimeout.current);
  }, [fraseIndex]);

  return (
    <section className="servicios-section">
      <h2 className="eventos-titulo servicios-titulo">
        <CounterServicios to={6} /> CARTERA DE SERVICIOS
      </h2>
      <p className={`servicios-slider-frase ${fraseAnim}`}>{frasesSlider[fraseIndex]}</p>
      <div className="servicios-grid">
        {servicios.map((serv, i) => (
          <ServicioCard key={i} serv={serv} index={i} />
        ))}
      </div>
    </section>
  );
} 